// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2_2Ij","subheader":"ReorderModal_subheader__3nmDc","listWrap":"ReorderModal_listWrap__2GsQZ"};